const getURL = ( url, success, error ) => {
	if ( !window.XMLHttpRequest ) return;
	let request = new XMLHttpRequest();

	request.onreadystatechange = () => {
		if ( request.readyState === 4 ) {
			if ( request.status !== 200 ) {
				if ( error && typeof error === 'function' ) {
					error( request.responseText, request );
				}
				return;
			}

			if ( success && typeof success === 'function' ) {
				success( request.responseText, request );
			}
		}
	};

	request.open( 'GET', url );
	request.send();
};

/**
 * Функция создания урла для строки браузера
 * @type {string}
 */
// const urlTemplate = '/%locale%/search/%query%/%sort_by%/%page%/';
const urlTemplate = '/search/%query%/%sort_by%/%page%/';
const createUrl = state => {
	let arr = urlTemplate.split('/');
	arr = arr.filter( item => item.length );

	let result = '/';

	arr.forEach( item => {
		item = item.replace(/%/g, '');

		switch( item ){
			case 'locale':
				result += state[item] ? state[item] : 'en';
				result += '/';
				break;
			case 'search':
				result += 'search/';
				break;
			case 'query':
				result += state[item] ? state[item] + '/' : '';
				break;
			case 'sort_by':
				result += (!state[item] || state[item] === 'relevance') ? '' : state[item] + '/';
				break;
			case 'page':
				result += (!state[item] || +state[item] === 1) ? '' : state[item] + '/';
				break;
		}
	});

	return result;
};


/**
 * Функция создания урла для запроса к серверу
 * @type {string}
 */
const ajaxUrlTemplate = '/ssearch/search.php?query=%query%&from=%page%&limit=%limit%&sort_by=%sort_by%';
const createAjaxUrl = data => {

	return ajaxUrlTemplate.replace(/(%query%)|(%page%)|(%limit%)|(%sort_by%)/gi, (...rest) => {
		if( /query/.test(rest[0]) )
			return data.query;
		else if( /page/.test(rest[0]) )
			return data.page;
		else if( /limit/.test(rest[0]) )
			return data.limit;
		else if( /sort_by/.test(rest[0]) )
			return data.sort_by;
	});

};


/**
 * Парсер урла. Использует при загрузке страницы для считывания состояний пагинатора и сортировки
 * @param string
 * @returns {{}}
 */
const urlParser = string => {
	let res = {};
	let arr = string.split('/').filter( item => item );

	if( arr[2] && isNaN( arr[2] ) ) res.sort_by = arr[ 2 ];

	if( arr[2] && !isNaN( arr[2] ) ) res.page = +arr[ 2 ];
	if( arr[3] && !isNaN( arr[3] ) ) res.page = +arr[ 3 ];

	return res;
};


const findInArr = (arr, str) => {
	if(!arr || !arr.length) return false;

	let result = false;

	for(let i=0; i<arr.length; i+=1){
		if(arr[i] === str) result = true;
	}

	return result;
};


const formatTime = timeInSec => {
	let hours = Math.floor(timeInSec / 3600),
		min = Math.floor((timeInSec % 3600) / 60),
		sec = Math.floor((timeInSec % 3600) % 60);

	min = min < 10 ? '0' + min : min;
	sec = sec < 10 ? '0' + sec : sec;

	return hours > 0 ?  hours + ':' + min + ':' + sec : min + ':' + sec;
};

const formatData = (data, state) => {
	return data.map( item => {
		item.duration = formatTime( item.duration );
		item.tags_str = item.tags_str.split(',').map( tag => {
			return {
				name: tag,
				link: state.locale ?
					'/' + state.locale + '/' + tag.split(' ').join('%20') + '/' :
					'/' + tag.split(' ').join('%20') + '/'
			}
		});
		return item;
	});
};

export {getURL, formatData, formatTime, createUrl, createAjaxUrl, findInArr, urlParser};



// WEBPACK FOOTER //
// ./src/desktop/scripts/searchPageComponents/utils.js